import { TLocalizedMessages } from './types'

export const chooseFileMessages: TLocalizedMessages = {
  en: {
    body: 'Choose File',
  },
  es: {
    body: 'Elija el archivo',
  },
  fr: {
    body: 'Choisir le fichier',
  },
  ja: {
    body: 'ファイルを選ぶ',
  },
  zh: {
    body: '选择文件',
  },
  ru: {
    body: 'Выберите файл',
  },
  de: {
    body: 'Datei wählen',
  },
  pt: {
    body: 'Escolher arquivo',
  },
  hi: {
    body: 'फाइलें चुनें',
  },
  id: {
    body: 'Pilih File',
  },
  he: {
    body: 'בחר קובץ',
  },
  ko: {
    body: '파일을 선택',
  },
  it: {
    body: 'Scegli il file',
  },
  ar: {
    body: 'اختر ملف',
  },
}

export const chooseFileTypeMessages: TLocalizedMessages = {
  en: {
    body: 'Choose File Type',
  },
  es: {
    body: 'Elija el tipo de archivo',
  },
  fr: {
    body: 'Choisir le type de fichier',
  },
  ja: {
    body: 'ファイルタイプを選ぶ',
  },
  zh: {
    body: '选择文件类型',
  },
  ru: {
    body: 'Выберите тип файла',
  },
  de: {
    body: 'Dateityp wählen',
  },
  pt: {
    body: 'Escolher tipo de arquivo',
  },
  hi: {
    body: 'फाइल के प्रकार चुनें',
  },
  id: {
    body: 'Pilih Tipe File',
  },
  he: {
    body: 'בחר סוג קובץ',
  },
  ko: {
    body: '파일 유형 선택',
  },
  it: {
    body: 'Scegli il tipo di file',
  },
  ar: {
    body: 'اختر نوع الملف',
  },
}

export const fileMessages: TLocalizedMessages = {
  en: {
    body: 'File',
  },
  es: {
    body: 'Archivo',
  },
  fr: {
    body: 'Fichier',
  },
  ja: {
    body: 'ファイル',
  },
  zh: {
    body: '文件',
  },
  ru: {
    body: 'Файл',
  },
  de: {
    body: 'Datei',
  },
  pt: {
    body: 'Arquivo',
  },
  hi: {
    body: 'फाइल',
  },
  id: {
    body: 'File',
  },
  he: {
    body: 'קובץ',
  },
  ko: {
    body: '파일',
  },
  it: {
    body: 'File',
  },
  ar: {
    body: 'ملف',
  },
}
